<template>
  <b-modal
    :id="modalId"
    centered
    hide-header
    :size="size || 'md'"
    button-size="sm"
    ok-variant="success"
    header-bg-variant="danger"
    :ok-title="$t('button.save.label')"
    :cancel-title="$t('button.cancel.label')"
    header-class="p-2 border-bottom-1"
    footer-class="p-1 border-top-0"
    header-text-variant="light"
    body-bg-variant="dark"
    body-text-variant="light"
    footer-bg-variant="dark"
    cancel-variant="danger"
    @show="onShow"
    @ok="onOk"
  >
    <b-form ref="formObjects" @submit.stop.prevent="handleSubmit">
      <object-select v-model="form.object" />
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'ObjectModalForm',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    size: {
      type: String,
    },
  },
  data() {
    return {
      value: '',
      form: {
        object: '',
      },
    };
  },
  methods: {
    onOk(e) {
      e.preventDefault();

      this.handleSubmit();
    },
    onShow() {
      this.form = { object: '00001' };
    },
    handleSubmit() {
      alert(this.form.object);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.modalId);
      });
    },
  },
};
</script>

<style></style>
